import React, { Component } from 'react'
import MaterialIcon, { colorPalette } from 'material-icons-react';
import Loader from "components/elements/loader/Loader";
import HttpClient from "../../utils/HttpClient/HttpClient";
import history from 'routes/History/history';
import * as qs from "qs";
import { showWarningMessage, showSuccessfulMessage, showErrorMessage } from 'reducers/application/applicationActions';
import { connect } from "react-redux";
import jwt_decode from 'jwt-decode';

class ResetPassword extends Component {

  httpClient;

  constructor(props) {
    super(props);
    this.state = {
      firstPassword: '',
      secondPassword: '',
      token: '',
      userName: '',
      loading: false
    }
    this.httpClient = new HttpClient();
  }

  componentDidMount() {
    const queryParams = this.props.location.search;
    const params = new URLSearchParams(queryParams.replace("?", ""));

    const token = params.get('token');
    if (token != null && token !== "") {
      var jwtDecoded = jwt_decode(token);
      this.setState({
        token: token,
        userName: jwtDecoded.sub
      });
    } else {
      setTimeout(
        function () {
          this.props.showErrorMessage("URL de restablecer contraseña inválido");
          history.push("/");
        }.bind(this),
        700
      );
    }
  }
  onFirstPasswordChange = (val) => {
    this.setState({ firstPassword: val });
  }

  onSecondPasswordChange = (val) => {
    this.setState({ secondPassword: val });
  }

  onSendResetPassword = () => {
    if (this.validate()) {
      this.setState({ loading: true });
      const config = { headers: { 'Content-Type': 'application/json' } };
      let data = {
        token: this.state.token,
        password: this.state.firstPassword,
        repeatPassword: this.state.secondPassword
      }
      this.httpClient.post("oga/reset-password", data, config)
        .then((response) => {
          this.setState({ loading: false });
          this.props.showSuccessfulMessage("Tu contraseña ha sido restablecida correctamente.");
          history.push('/');
        })
        .catch((error) => {
          this.setState({ loading: false });
          this.props.showWarningMessage("Ha ocurrido un error. Por favor intentelo más tarde.");
        })
    }
  }

  validate = () => {
    if (this.state.firstPassword.length == 0) {
      this.props.showWarningMessage("Ingrese 'Nueva Contraseña' ");
      return false;
    }
    if (this.state.secondPassword.length == 0) {
      this.props.showWarningMessage("Ingrese 'Repite nueva contraseña'");
      return false;
    }
    if (this.state.firstPassword !== this.state.secondPassword) {
      this.props.showWarningMessage("Las contraseñas ingresadas deben ser iguales");
      return false;
    }
    return true;
  }

  render() {
    return (
      <form className="form">
        <div className="w-100">
          <div className="text-center text-white forgot-password_title">Restablece tu contraseña</div>
        </div>

        <div className="form-group">
          <div className="input-group mb-3 password">
            <div className="input-group-prepend " >
              <span className="input-group-text border-dark bg-secondary">
                <MaterialIcon icon="https" size="18px" color="white" />
              </span>
            </div>
            <input type="password" className="form-control border-dark"
              onChange={(e) => this.onFirstPasswordChange(e.target.value)}
              aria-describedby="emailHelp" placeholder="Nueva contraseña" />
          </div>
        </div>

        <div className="form-group">
          <div className="input-group mb-3 password">
            <div className="input-group-prepend " >
              <span className="input-group-text border-dark bg-secondary">
                <MaterialIcon icon="https" size="18px" color="white" />
              </span>
            </div>
            <input type="password" className="form-control border-dark"
              onChange={(e) => this.onSecondPasswordChange(e.target.value)}
              aria-describedby="emailHelp" placeholder="Repite nueva contraseña" />
          </div>
        </div>

        <div className="w-100">
          {
            this.state.loading ? <Loader show={true} /> :
              <button type="button"
                className="btn bg-secondary w-100 login-btn"
                onClick={() => this.onSendResetPassword()}>Restablecer contraseña</button>
          }
        </div>
      </form>
    )
  }
}
const mapStateToProps = state => ({
});
export default connect(
  mapStateToProps,
  { showWarningMessage, showSuccessfulMessage, showErrorMessage }
)(ResetPassword);



// WEBPACK FOOTER //
// ./src/views/ResetPassword/ResetPassword.jsx